/**
 * CloudFront CDN origin for game cutscene video clips (TEX-1438).
 *
 * Build-time var (baked into the client bundle like VITE_API_BASE_URL), e.g.
 * `https://d3punov9baes5l.cloudfront.net`. Empty when unset → the portal hands
 * games a same-origin video base and clips resolve from disk via the Vite
 * game-assets plugin (dev) or the build output. Kept SEPARATE from the
 * same-origin asset path so only large .mp4 clips go through the CDN.
 *
 * Mirrors getApiBaseUrl() in ./api.ts.
 */
export function getVideoCdn(): string {
  const fromEnv =
    typeof import.meta !== "undefined" && import.meta.env
      ? import.meta.env.VITE_VIDEO_CDN
      : undefined;
  return (fromEnv ?? "").replace(/\/$/, "");
}
